/**
 * V1.1 Task 4 — pure presentational sub-component for the most recent
 * orphan-audit dry-run summary card.
 */

import type { OrphanAuditReport } from "../../../api/admin-storage-orphan-audit";
import { t } from "../../../i18n";
import {
  formatBytes,
  formatIso,
  auditStyles as styles,
} from "./storage-orphan-audit-helpers";

function Field({
  label,
  value,
}: {
  label: string;
  value: string;
}): React.JSX.Element {
  return (
    <div style={styles.field}>
      <dt style={styles.fieldLabel}>{label}</dt>
      <dd style={styles.fieldValue}>{value}</dd>
    </div>
  );
}

export function LatestRunCard({
  run,
}: {
  run: NonNullable<OrphanAuditReport["latest_run"]>;
}): React.JSX.Element {
  return (
    <section style={styles.card}>
      <h2 style={styles.cardTitle}>{t("storage_orphan_audit.latest_run")}</h2>
      <dl style={styles.dl}>
        <Field
          label={t("storage_orphan_audit.col_run_at")}
          value={formatIso(run.run_at)}
        />
        <Field
          label={t("storage_orphan_audit.col_count")}
          value={String(run.count)}
        />
        <Field
          label={t("storage_orphan_audit.col_bytes")}
          value={formatBytes(run.total_bytes)}
        />
        <Field
          label={t("storage_orphan_audit.col_oldest")}
          value={
            run.oldest_created_at_unix_ms !== null
              ? formatIso(run.oldest_created_at_unix_ms)
              : "—"
          }
        />
        <Field
          label={t("storage_orphan_audit.col_environment")}
          value={
            run.is_prod
              ? t("storage_orphan_audit.env_prod")
              : t("storage_orphan_audit.env_nonprod")
          }
        />
      </dl>
      {run.partial_scan && (
        <div style={styles.warning} role="alert">
          {t("storage_orphan_audit.partial_scan_warning")}
        </div>
      )}
    </section>
  );
}
